import { render } from "./marketScoreManage.vue?vue&type=template&id=a770be8a&scoped=true"
import script from "./marketScoreManage.vue?vue&type=script&lang=js"
export * from "./marketScoreManage.vue?vue&type=script&lang=js"

import "./marketScoreManage.vue?vue&type=style&index=0&id=a770be8a&scoped=true&lang=css"

import exportComponent from "D:\\未知比特项目\\前端项目\\adminSystem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a770be8a"]])

export default __exports__